import { Button } from '@/components/ui/button';
import { triggerMaterialityCheck } from '@/features/strategy/api';

/**
 * The Done button on both product-edit routes. Starts the report-freshness check
 * as a head start, then navigates — nothing about the check is shown here.
 *
 * The check is NOT guaranteed to run from here (a user can leave by breadcrumb,
 * browser back, or closing the tab), which is why the strategy page starts it too.
 * A failure here is therefore non-fatal: navigate regardless.
 */
export function DoneButton({
  productId,
  onDone,
}: {
  productId: number;
  onDone: () => void;
}) {
  const handleClick = async () => {
    try {
      await triggerMaterialityCheck(productId);
    } catch {
      // Non-fatal: the strategy page starts the check if this didn't.
    }
    onDone();
  };

  return (
    <Button type="button" variant="brand" onClick={() => void handleClick()}>
      Done
    </Button>
  );
}
